import { Connection } from '../../connections/connection.class';
import { Island } from '../island.class';
import { moveSourceIslandCfn } from '../../connections/functions';
import { Size } from '../../../types';

export const setSizeStandardPanelsCfn = (island: Island): void => {
	try {
		const size = island.size as Size;

		// During construction of loaded islands, preserve saved panel sizes.
		// Stale panel depths from corrupted saves are corrected by schema update 11.
		if (!island.initialized && !island.panels.isNew) return;

		const frontThickness = island.getThicknessForRole('front');
		const backThickness = island.getThicknessForRole('back');

		// Capture old panel height before updating so we can shift bottom-only items by the delta
		const oldPanelHeight = island.panels.children[0]?.size.height ?? size.height;

		// Front panel
		island.panels.children.filter((p) => p.id === island.panels.frontPanelId).forEach((p) => {
			p.size = {
				height: size.height,
				width: size.width,
				depth: frontThickness
			};
		});

		// Back panels
		island.panels.children.filter((p) => p.isBackPanel).forEach((p) => {
			p.size = {
				height: size.height,
				width: size.width,
				depth: backThickness
			};
		});

		// Side panels — width fills the gap between front and back panels
		island.panels.children.filter((p) => p.isSidePanel).forEach((p) => {
			p.size = {
				height: size.height,
				width: size.depth - (frontThickness + backThickness),
				depth: island.getThicknessForRole(p.isLeftPanel ? 'left' : 'right')
			};
		});

		// Only reposition after construction completes
		if (!island.initialized) return;

		// Shift bottom-only items by the same amount the bottom edge moved
		// so they stay in place relative to the panel bottom
		const heightDelta = (size.height - oldPanelHeight) / 2;
		if (heightDelta !== 0) {
			island.panels.children.forEach((p) => {
				p.panelItemGroups.children.forEach((group) => {
					group.items.children.forEach((pi) => {
						if (pi.boundBottom && !pi.boundTop && !pi.fullHeight) {
							pi.center.y += heightDelta;
						}
					});
				});
			});
		}

		if (island.connections.children.length > 0) {
			const connections = !island.connections.children[0].isSource
				? island.connections.children
				: island.connections.getSourceConnections();
			connections.forEach((c) => moveSourceIslandCfn(c as Connection));
		}
	} catch (error) {
		console.error(`setSizeStandardPanelsCfn:Error setting size for standard island panels ${island.id}:`, error);
	}
}
